export class Eco {
  public constructor(
    public id: string,
    public documentFormat: string,
    public link?: string
  ) {}
}
